export default __webpack_public_path__ + "static/media/icon-check-1.afeb2b3a.svg";